import { jsx as l } from "react/jsx-runtime";
const e = (t) => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 8 8", ...t, children: /* @__PURE__ */ l("path", { fill: "#212134", d: "M2 .93c0-.4.45-.63.78-.41l4.6 3.06c.3.2.3.64 0 .84l-4.6 3.06A.5.5 0 0 1 2 7.07V.93Z" }) }), i = e;
export {
  i as default
};
